import type { DefaultOptionType } from 'antd/lib/select';

import type { ApplicationRulesFormValues } from './types';

export const TIME_UNIT_OPTIONS: DefaultOptionType[] = [
  {
    label: '天',
    value: '天',
  },
  {
    label: '週',
    value: '週',
  },
  {
    label: '月',
    value: '月',
  },
];

export const INIT_RULES_FORM_VALUES: ApplicationRulesFormValues = {
  cancelReservation: {
    number: null,
    unit: null,
  },
  reviewExpiration: {
    number: null,
    unit: null,
  },
};
